// extracted by mini-css-extract-plugin
export default {"category":"Category_category__x8aL6","categoryLink":"Category_categoryLink__cMrLq","list":"Category_list__mbBZx"};